import { render, staticRenderFns } from "./configOnboarding.vue?vue&type=template&id=48c640ef&scoped=true"
import script from "./configOnboarding.vue?vue&type=script&lang=js"
export * from "./configOnboarding.vue?vue&type=script&lang=js"
import style0 from "./configOnboarding.vue?vue&type=style&index=0&id=48c640ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c640ef",
  null
  
)

export default component.exports